import { useState } from "react";
import "./products.css";
import appInsights from "../../../applicationInsights";

export default function ProductsSection() {
  const [activeTab, setActiveTab] = useState("agent");

  const content = {
    agent: {
      title: "RYSE Agent",
      text: `
        Each Agent in Ryse has a defined personality and a set of specialized
        analytical tools — from linear metrics and non-linear mathematics to
        Monte Carlo engines, cointegration, VaR, reporting, and more.
      `,
      highlight:
        "Speed, scalability, and efficiency for investment teams and research environments",
      cta: "Try RYSE Agent",
      URL: "/Login",
    },
    app: {
      title: "RYSE App",
      text: `
       The central workspace of the platform, unifying analytics, AI outputs, and portfolio intelligence into a single interface — from risk dashboards and performance views to stress testing, benchmarks, and simulations.
      `,
      highlight:
        "Clarity, accessibility, and institutional-grade visualization for faster, smarter decision-makings",
      cta: "Explore RYSE App",
      URL: "/Login",
    },
  };

  const handleProductSelect = (productId) => {
    appInsights.trackEvent({
      name: "ProductSelected",
      properties: {
        productId,
        productName: content[productId].title
      }
    });
    setActiveTab(productId);
  };

  const handleProductCtaClick = () => {
    const product = content[activeTab];
    appInsights.trackEvent({
      name: "ProductCtaClicked",
      properties: {
        productId: activeTab,
        productName: product.title,
        ctaLabel: product.cta,
        url: product.URL
      }
    });
    window.location.href = product.URL;
  };

  return (
    <section className="products-section p-40-20">
      <h2 className="products-title">Meet Our Products</h2>

      <div className="products-switch">
        <button
          className={`switch-btn ${activeTab === "agent" ? "active" : ""}`}
          onClick={() => handleProductSelect("agent")}
        >
          RYSE Agent
        </button>

        <button
          className={`switch-btn ${activeTab === "app" ? "active" : ""}`}
          onClick={() => handleProductSelect("app")}
        >
          RYSE App
        </button>
      </div>

      <div className="product-card ">
        <h3 className="product-card__title">{content[activeTab].title}</h3>

        <p className="product-card__text">{content[activeTab].text}</p>

        <p className="product-card__highlight">
          {content[activeTab].highlight}
        </p>

        <br />
        <button
          className="product-card__cta"
          onClick={handleProductCtaClick}
        >
          {content[activeTab].cta}
        </button>
      </div>
    </section>
  );
}
